export function reverseToIsoDate(date: string) {
  if (!date) return;

  const newDate = date.split("/").reverse().join("-");

  return newDate;
}

export function reverseToBrDate(date: string) {
  if (!date) return;

  const newDate = date.split("-").reverse().join("/");

  return newDate;
}

export function reverseToDateObject(date: string) {
  if (!date) return;
  
  const parts = date.split("-");
  return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
}

export function formatISOToDateBR(isoDate: string): string {
  const date = new Date(isoDate);
  
  if (isNaN(date.getTime())) {
    const cleaned = isoDate.slice(0, 23);
    return formatISOToDateBR(cleaned);
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatDateToISO(date: Date | null): string {

  if (!date || isNaN(date.getTime()))
    return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
